const initialState = {
  data: [],
  loading: false
}

const albumsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ALBUMS_FETCH_REQUESTED':
      return { ...state, loading: true }

    case 'ALBUMS_FETCH_SUCCEEDED':
      return { ...state, loading: false, data: action.response }

    case 'ALBUMS_FETCH_FAILED':
      return initialState

    default:
      return state
  }
}

export default albumsReducer
